import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async getBadgeValue() {
    const request = await api.get('/aprovacoes/contagem')
    return factory.build(request)
  },
}
